import {
  CircularProgress,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import GroupIcon from '@material-ui/icons/Group';
import { StatusIcon } from 'components/TableItems';
import { styleStatus } from './styles';

const useStyles = makeStyles(styleStatus);

interface Props {
  value: string;
  hiddenText?: boolean;
}

const StatusInstance = ({ value, hiddenText }: Props) => {
  const classes = useStyles();

  const getCustom = () => {
    const status = value.toUpperCase();

    let custom = {
      icon: <></>,
      color: '',
      textOpacity: false,
    };

    if (['INICIALIZANDO', 'ATIVANDO'].includes(status)) {
      custom = {
        icon: <CircularProgress size={15} color="secondary" />,
        color: '',
        textOpacity: true,
      };
    } else if (['OPERACIONAL'].includes(status)) {
      custom = {
        icon: <StatusIcon status="success" />,
        color: '',
        textOpacity: false,
      };
    } else if (['INACESSIVEL'].includes(status)) {
      custom = {
        icon: <StatusIcon status="blocked" />,
        color: '',
        textOpacity: false,
      };
    } else if (['LIGADA'].includes(status)) {
      custom = {
        icon: <CircularProgress size={15} color="secondary" />,
        color: '',
        textOpacity: false,
      };
    } else if (['TERMINANDO', 'PARANDO'].includes(status)) {
      custom = {
        icon: <CircularProgress size={15} style={{ color: 'orange' }} />,
        color: '',
        textOpacity: true,
      };
    } else if (['BLOQUEADA', 'PARADA', 'ERRO'].includes(status)) {
      custom = {
        icon: <StatusIcon status="inactive" />,
        color: '',
        textOpacity: false,
      };
    } else if (['CHEIA'].includes(status)) {
      custom = {
        icon: <GroupIcon style={{ fontSize: 13 }} />,
        color: 'red',
        textOpacity: false,
      };
    }

    return custom;
  };

  return (
    <Grid container wrap="nowrap" alignItems="center" justify="center">
      <span className={clsx(classes.icon, classes[getCustom().color])}>
        {getCustom().icon}
      </span>
      {!hiddenText && (
        <Typography variant="body2" className={classes.textOpacity}>
          {value}
        </Typography>
      )}
    </Grid>
  );
};

export default StatusInstance;
